/**
 * Cal Frontend API client
 * All calls go to cal.forgelinesystems.com/api/*
 */

const BASE = process.env.REACT_APP_CAL_API_BASE || 'https://cal.forgelinesystems.com/api';

function getToken() {
  return localStorage.getItem('cal_supabase_token') || '';
}

async function request(method, path, body, token) {
  const t = token || getToken();
  const headers = { 'Content-Type': 'application/json' };
  if (t) headers['Authorization'] = `Bearer ${t}`;

  const res = await fetch(BASE + path, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (res.status === 204) return null;

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    const err = new Error(data.error || `Request failed: ${res.status}`);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}

// Public routes (no auth)
export const publicApi = {
  getCalendar: (slug) => request('GET', `/public/calendar/${slug}`),
  createBooking: (body) => request('POST', '/public/bookings', body),
};

// Owner routes (JWT required)
export const ownerApi = {
  getCalendars: (token) => request('GET', '/owner/calendars', null, token),
  updateCalendar: (id, body, token) => request('PATCH', `/owner/calendars/${id}`, body, token),
  getBookings: (params = {}, token) => {
    const qs = new URLSearchParams();
    if (params.calendar_id) qs.set('calendar_id', params.calendar_id);
    if (params.status) qs.set('status', params.status);
    if (params.limit) qs.set('limit', params.limit);
    if (params.offset) qs.set('offset', params.offset);
    return request('GET', `/owner/bookings?${qs}`, null, token);
  },
  cancelBooking: (id, token) => request('DELETE', `/owner/bookings/${id}`, null, token),
  getProfile: (token) => request('GET', '/owner/profile', null, token),
  updateProfile: (body, token) => request('PATCH', '/owner/profile', body, token),
  getBlocks: (token, calendarId) => request('GET', `/owner/blocks?calendar_id=${calendarId}`, null, token),
  createBlock: (token, { calendar_id, starts_at, ends_at, reason }) => request('POST', '/owner/blocks', { calendar_id, starts_at, ends_at, reason }, token),
  deleteBlock: (token, blockId, calendarId) => request('DELETE', `/owner/blocks/${blockId}`, { calendar_id: calendarId }, token),
};
